









































































































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import InstitutionState from '@/components/Settings/Institutions/InstitutionState.vue';

@Component({ name: 'InstitutionDetails', components: { InstitutionState } })
export default class extends SaascadaVue {

    get institution() {
        return InstitutionsModule.institution;
    }

    get coreApiSwagger() {
        // TODO: This is currently taken from the go backend hardcoded field for CoreApiSwagger but will be removed eventually
        return AuthModule.me.institution.config.coreApiSwagger;
    }

    get availableCurrencies() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailableCurrencies
        // But once this has been added to the main config the function can be swapped for just "institution.availableCurrencies"
        return AuthModule.me.institution.config.availableCurrencies;
    }

    get availablePaymentSchemes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePaymentSchemes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePaymentSchemes"
        return AuthModule.me.institution.config.availablePaymentSchemes;
    }

    get availablePayeeTypes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePayeeTypes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePayeeTypes"
        return AuthModule.me.institution.config.availablePayeeTypes;
    }

}
